import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export default () => {
  const {
    screenSizes,
    spacing,
    colors,
    utility,
    borderRadius,
    breakpoints,
    mediaQueries,
  } = useTheme();

  return {
    base: (isVisible, isNarrowScreen, backlinkcta) => css`
      display: grid;
      align-items: center;
      justify-items: center;
      position: absolute;
      z-index: 11;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 100%;
      margin-left: 50%;
      transition: transform 0.5s ease-out;
      transform: translateX(-50%) translateY(100%);
      background: url(${publicPath(
        '/images/mobile/onboarding/onboarding_mobile_bg.webp'
      )});
      background-size: cover;
      background-color: ${colors.white};
      // padding: ${spacing.s} ${spacing.m};

      ${isVisible &&
      css`
        transform: translate(-50%, 0%);

        ${breakpoints.m} {
          margin-left: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          ${
            backlinkcta === true &&
            css`
              // transition: transform 0.5s ease-out;
              // transform: translate(0,-144%);
            `
          }
      `}

      ${breakpoints.l} {
        align-items: center;
        max-width: 100%;
        height: 100%;
        background-image: url(${publicPath(
          '/images/desktop/onboarding/onboarding_bg.webp'
        )});
        background-color: ${colors.white};
        padding: ${isNarrowScreen ? '2rem 3rem' : '7rem'};

        /* EDGE CASE OF SUPER NARROW SCREEN
          Using this instead of media-query in the CSS
          as for some reason max-height is not being
          picked up by the browser */
        ${isNarrowScreen &&
        css`
          li {
            padding-bottom: ${spacing.s};

            button {
              padding: 1.6rem;
            }
          }
        `}

        ${breakpoints.xl} {
          max-width: 100%;
        }
      }

      ${mediaQueries.zoomedIn ||
      mediaQueries.zoomedInL2 ||
      mediaQueries.zoomedInL3} {
        background-position: 0 250%;
      }

      ${mediaQueries.iphoneZoom} {
        background-position: 0 250%;
      }
    `,
    // Updated progressBar function for fixed position and 100% width
    progressBar: progressPercentage => css`
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      border: none;
      background: ${colors.greyLight};
      position: fixed; // Change position to fixed
      display: block;
      top: 0;
      left: 0;
      width: 100%; // Set width to 100%
      height: 6px;
      z-index: 100; // Ensure it stays on top of other content

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: ${colors.grey};
      }

      &::-webkit-progress-value {
        background-color: ${colors.red};
        transition: width 0.5s;
      }

      &::-moz-progress-bar {
        background-color: ${colors.red};
        transition: width 0.5s;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: ${progressPercentage}%;
        transition: width 0.5s ease-in;
        background-color: ${colors.red};
      }
    `,
    overlay: css`
      ${utility.overlay};
    `,
    closeBtn: css`
      ${utility.buttonDefault};
      position: absolute;
      border-radius: 50%;
      top: 2rem;
      right: 1rem;
      width: 40px;
      height: 40px;
      outline: 0;

      svg {
        padding: 0.1rem;
        border: 2px solid transparent;
        color: ${colors.navy};
        &:hover {
          path {
            stroke: ${colors.navy};
          }
          circle {
            fill-opacity: 1;
            stroke: ${colors.navy};
          }
        }
      }

      &:focus {
        svg {
          padding: 0.1rem;
          border: ${borderRadius.s} solid ${colors.navy};
          border-radius: 50%;
        }
      }
      &:focus-visible {
        svg {
          border-radius: 50%;
          outline: 2px solid ${colors.skip_yellow};
          border: 2px solid ${colors.border_black};
        }
      }

      ${breakpoints.l} {
        right: 3rem;
        top: 3rem;
      }

      ${mediaQueries.zoomedIn ||
      mediaQueries.zoomedInL2 ||
      mediaQueries.zoomedInL3} {
        // background: ${colors.white};
        z-index: 2;
      }

      ${mediaQueries.iphoneZoom} {
        // background: ${colors.white};
        z-index: 2;
      }
    `,
    question: css`
      width: 83%;
      @media (max-width: ${screenSizes.l}) {
        width: 327px;
        display: grid;
        position: relative;
        justify-content: space-around;
      }

      ${mediaQueries.zoomedIn ||
      mediaQueries.zoomedInL2 ||
      mediaQueries.zoomedInL3} {
        position: unset;
        overflow: auto;
      }

      ${mediaQueries.iphoneZoom} {
        position: unset;
        overflow: auto;
      }
    `,
    // When the button would go over the content (ie zoom)
    // we want a white background for the button
    fakeButtonOverlay: css`
      display: none;

      ${mediaQueries.zoomedIn ||
      mediaQueries.zoomedInL2 ||
      mediaQueries.zoomedInL3} {
        display: block;
        position: absolute;
        bottom: ${spacing.xs};
        left: ${spacing.m};
        right: ${spacing.m};
        bottom: ${spacing.xs};
        height: 1.875rem;
        // background: white;
        z-index: 1;
      }

      ${mediaQueries.iphoneZoom} {
        display: block;
        position: absolute;
        bottom: ${spacing.xs};
        left: ${spacing.m};
        right: ${spacing.m};
        bottom: ${spacing.xs};
        height: 1.875rem;
        // background: white;
        z-index: 1;
      }
    `,
  };
};
